import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/performance/hok.jpg'

const _withId = /*#__PURE__*/_withScopeId("data-v-b6dd4a46")

_pushScopeId("data-v-b6dd4a46")
const _hoisted_1 = { style: {"height":"100%","position":"relative"} }
const _hoisted_2 = { style: {"position":"fixed","z-index":"1000","top":"0","left":"0","right":"0"} }
const _hoisted_3 = {
  class: "new_head",
  style: {"width":"100%","background":"#2d3136","height":"62px"}
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("span", null, [
    /*#__PURE__*/_createVNode("img", {
      style: {"height":"44px","width":"48px","border-radius":"10px","margin-right":"10px"},
      src: _imports_0
    })
  ]),
  /*#__PURE__*/_createVNode("span", {
    class: "geo-style2",
    style: {"font-size":"21px","color":"#fff"}
  }, "sgame皮肤性能平台")
], -1)
const _hoisted_5 = { style: {"position":"absolute","top":"62px","left":"0","right":"0","bottom":"0","overflow-y":"auto"} }
const _hoisted_6 = {
  style: {"width":"100%","padding":"50px","background":"#222529"},
  class: "Ecard",
  id: "trendChart"
}
const _hoisted_7 = {
  class: "testMain",
  style: {"background":"#2d3136"}
}
const _hoisted_8 = {
  style: {"display":"flex","justify-content":"space-between","align-items":"center","background":"#2d3136","color":"#fff","padding":"10px 10px"},
  class: "hok_label"
}
const _hoisted_9 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_10 = { class: "current_img" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("切换英雄皮肤")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_13 = { class: "spacName" }
const _hoisted_14 = /*#__PURE__*/_createVNode("h5", { style: {"color":"#fff"} }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("局内皮肤性能数据")
], -1)
const _hoisted_15 = { style: {"color":"#70c1f1"} }
const _hoisted_16 = { class: "spacName" }
const _hoisted_17 = /*#__PURE__*/_createVNode("h5", { style: {"color":"#fff"} }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("局外皮肤性能数据")
], -1)
const _hoisted_18 = { style: {"color":"#70c1f1"} }
const _hoisted_19 = { style: {"color":"#70c1f1"} }
const _hoisted_20 = { class: "spacName" }
const _hoisted_21 = /*#__PURE__*/_createVNode("h5", { style: {"color":"#fff"} }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("局内性能皮肤趋势图")
], -1)
const _hoisted_22 = {
  "element-loading-background": "#393E44",
  style: {"width":"100%","height":"350px"},
  id: "skin_inside"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("h5", { style: {"color":"#fff"} }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("局外性能皮肤趋势图")
], -1)
const _hoisted_24 = {
  "element-loading-background": "#393E44",
  style: {"width":"100%","height":"350px"},
  id: "skin_out"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_card = _resolveComponent("el-card")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", null, [
          _createVNode("span", null, [
            _createVNode("img", {
              style: {"height":"50px","width":"55px","border-radius":"25px"},
              src: 
                'https://dayu.woa.com/avatars/' + _ctx.name_img + '/profile.jpg'
              
            }, null, 8, ["src"])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("span", _hoisted_10, [
                _createVNode("img", { src: _ctx.skin_icon }, null, 8, ["src"])
              ]),
              _createVNode("div", null, [
                _createVNode("div", null, _toDisplayString(_ctx.hero_name + "-" + _ctx.skin_name), 1)
              ])
            ]),
            _createVNode("div", null, [
              (_ctx.checkHok)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    size: "mini",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkHok = false))
                  }, {
                    default: _withId(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_el_form, {
                    key: 1,
                    inline: true,
                    size: "mini"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "选择英雄" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.skin_id = '')),
                            filterable: "",
                            modelValue: _ctx.hero_id,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.hero_id = $event))
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.hokIcon?.hero_list, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.hero_id,
                                  label: item.hero_name,
                                  value: item.hero_id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "选择皮肤" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.skin_id,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.skin_id = $event))
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.hokIcon?.skin_list[_ctx.hero_id], (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.skin_id,
                                  label: item.skin_name,
                                  value: item.skin_id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "mini",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirm()))
                          }, {
                            default: _withId(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
            ])
          ]),
          _createVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createVNode(_component_el_table, {
              class: "my-table-hok",
              "span-method": _ctx.mergeCells1,
              size: "mini",
              "header-cell-style": {
                background: '#42484E',
                color: '#fff',
              },
              "element-loading-background": "#42484E",
              data: _ctx.hok_inside_table
            }, {
              default: _withId(() => [
                _createVNode(_component_el_table_column, {
                  width: "170",
                  label: "机型"
                }, {
                  default: _withId((scope) => [
                    _createTextVNode(_toDisplayString(_ctx.extractBracketContents(scope.row.model).textOutsideBrackets), 1),
                    _createVNode("span", _hoisted_15, _toDisplayString(_ctx.extractBracketContents(scope.row.model).textInsideBrackets), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "帧率" }, {
                  default: _withId((scope) => [
                    _createVNode("span", null, _toDisplayString(scope.row.data.frame_rate), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  width: "210",
                  label: "版本日期"
                }, {
                  default: _withId((scope) => [
                    _createVNode("span", {
                      style: 
                      'margin-left:' +
                      (scope.row.data.level == 0 ? '0px' : '10px')
                    
                    }, [
                      _createTextVNode(_toDisplayString(scope.row.data.date), 1),
                      (scope.row.data.level == 0 && scope.row.show)
                        ? (_openBlock(), _createBlock("i", {
                            key: 0,
                            style: {"cursor":"pointer"},
                            onClick: ($event: any) => (_ctx.expandCheck(scope.row)),
                            class: 
                        scope.row.check
                          ? 'el-icon-arrow-down'
                          : 'el-icon-arrow-up'
                      
                          }, null, 10, ["onClick"]))
                        : _createCommentVNode("", true)
                    ], 4)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "结论" }, {
                  default: _withId((scope) => [
                    _createVNode("span", {
                      class: 
                      scope.row.data.risk == '达标'
                        ? 'com_risk_green'
                        : 'com_risk_red'
                    
                    }, _toDisplayString(scope.row.data.risk), 3)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "avgFps" }, {
                  default: _withId((scope) => [
                    _createVNode("span", {
                      class: scope.row.data.avg_fps_risk ? 'com_risk_red' : ''
                    }, _toDisplayString(scope.row.data.avg_fps), 3)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "miniFps" }, {
                  default: _withId((scope) => [
                    _createVNode("span", null, _toDisplayString(scope.row.data.min_fps), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "帧率方差" }, {
                  default: _withId((scope) => [
                    _createVNode("span", null, _toDisplayString(scope.row.data.var_fps), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "avgCpu" }, {
                  default: _withId((scope) => [
                    _createVNode("span", null, _toDisplayString(scope.row.data.avg_cpu), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "avgGpu" }, {
                  default: _withId((scope) => [
                    _createVNode("span", null, _toDisplayString(scope.row.data.gpu_usage), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "maxPss" }, {
                  default: _withId((scope) => [
                    _createVNode("span", null, _toDisplayString(scope.row.data.max_pss), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "avgPss" }, {
                  default: _withId((scope) => [
                    _createVNode("span", null, _toDisplayString(scope.row.data.avg_pss), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "maxVss" }, {
                  default: _withId((scope) => [
                    _createVNode("span", null, _toDisplayString(scope.row.data.max_vss), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "avgVss" }, {
                  default: _withId((scope) => [
                    _createVNode("span", null, _toDisplayString(scope.row.data.avg_vss), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "链接" }, {
                  default: _withId((scope) => [
                    _createVNode("span", null, [
                      _createVNode("a", {
                        target: "_blank",
                        style: {"cursor":"pointer","color":"#70c1f1"},
                        href: scope.row.data.url
                      }, "查看", 8, ["href"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["span-method", "data"]), [
              [_directive_loading, _ctx.inside_loading]
            ])
          ]),
          _createVNode("div", _hoisted_16, [
            _hoisted_17,
            _withDirectives(_createVNode(_component_el_table, {
              class: "my-table-hok",
              size: "mini",
              "header-cell-style": {
                background: '#42484E',
                color: '#fff',
              },
              "element-loading-background": "#42484E",
              data: _ctx.hok_out_table,
              "span-method": _ctx.mergeCells
            }, {
              default: _withId(() => [
                _createVNode(_component_el_table_column, {
                  width: "170",
                  label: "机型"
                }, {
                  default: _withId((scope) => [
                    _createTextVNode(_toDisplayString(_ctx.extractBracketContents(scope.row.model).textOutsideBrackets), 1),
                    _createVNode("span", _hoisted_18, _toDisplayString(_ctx.extractBracketContents(scope.row.model).textInsideBrackets), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "帧率" }, {
                  default: _withId((scope) => [
                    _createVNode("span", null, _toDisplayString(scope.row.data.frame_rate), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "动作",
                  prop: "action"
                }, {
                  default: _withId((scope) => [
                    _createVNode("span", _hoisted_19, _toDisplayString(scope.row.action), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  width: "210",
                  label: "版本日期"
                }, {
                  default: _withId((scope) => [
                    _createVNode("span", {
                      style: 
                      'margin-left:' +
                      (scope.row.data.level == 0 ? '0px' : '10px')
                    
                    }, [
                      _createTextVNode(_toDisplayString(scope.row.data.date), 1),
                      (scope.row.data.level == 0 && scope.row.show)
                        ? (_openBlock(), _createBlock("i", {
                            key: 0,
                            style: {"cursor":"pointer"},
                            onClick: ($event: any) => (_ctx.expandCheckOut(scope.row)),
                            class: 
                        scope.row.check
                          ? 'el-icon-arrow-down'
                          : 'el-icon-arrow-up'
                      
                          }, null, 10, ["onClick"]))
                        : _createCommentVNode("", true)
                    ], 4)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "结论" }, {
                  default: _withId((scope) => [
                    _createVNode("span", {
                      class: 
                      scope.row.data.risk == '达标'
                        ? 'com_risk_green'
                        : 'com_risk_red'
                    
                    }, _toDisplayString(scope.row.data.risk), 3)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "avgFps" }, {
                  default: _withId((scope) => [
                    _createVNode("span", {
                      class: scope.row.data.avg_fps_risk ? 'com_risk_red' : ''
                    }, _toDisplayString(scope.row.data.avg_fps), 3)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "miniFps" }, {
                  default: _withId((scope) => [
                    _createVNode("span", null, _toDisplayString(scope.row.data.min_fps), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "帧率方差" }, {
                  default: _withId((scope) => [
                    _createVNode("span", null, _toDisplayString(scope.row.data.var_fps), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "avgCpu" }, {
                  default: _withId((scope) => [
                    _createVNode("span", null, _toDisplayString(scope.row.data.avg_cpu), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "avgGpu" }, {
                  default: _withId((scope) => [
                    _createVNode("span", null, _toDisplayString(scope.row.data.gpu_usage), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "maxPss" }, {
                  default: _withId((scope) => [
                    _createVNode("span", null, _toDisplayString(scope.row.data.max_pss), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "avgPss" }, {
                  default: _withId((scope) => [
                    _createVNode("span", null, _toDisplayString(scope.row.data.avg_pss), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "maxVss" }, {
                  default: _withId((scope) => [
                    _createVNode("span", null, _toDisplayString(scope.row.data.max_vss), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "avgVss" }, {
                  default: _withId((scope) => [
                    _createVNode("span", null, _toDisplayString(scope.row.data.avg_vss), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "链接" }, {
                  default: _withId((scope) => [
                    _createVNode("span", null, [
                      _createVNode("a", {
                        target: "_blank",
                        style: {"cursor":"pointer","color":"#70c1f1"},
                        href: scope.row.data.url
                      }, "查看", 8, ["href"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "span-method"]), [
              [_directive_loading, _ctx.out_loading]
            ])
          ]),
          _createVNode("div", _hoisted_20, [
            _hoisted_21,
            _createVNode(_component_el_form, {
              class: "spacName hok_label_form",
              inline: true,
              size: "mini"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, { label: "选择设备" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.device_in,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.device_in = $event)),
                      size: "mini",
                      filterable: "",
                      placeholder: "选择设备",
                      onChange: _ctx.deviceInChange
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_list, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item,
                            label: item.model,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "选择指标" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.target_index,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.target_index = $event)),
                      size: "mini",
                      filterable: "",
                      placeholder: "选择指标",
                      onChange: _ctx.hokinsideChange
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.target_types, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item,
                            label: item,
                            value: item
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_card, {
              class: "hok_card",
              style: {"background":"#393e44","border":"1px solid #fff"}
            }, {
              default: _withId(() => [
                _withDirectives(_createVNode("div", _hoisted_22, null, 512), [
                  [_directive_loading, _ctx.inside_trend_loading]
                ])
              ]),
              _: 1
            })
          ]),
          _createVNode("div", null, [
            _hoisted_23,
            _createVNode(_component_el_form, {
              class: "spacName hok_label_form",
              inline: true,
              size: "mini"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, { label: "选择设备" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.device_out,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.device_out = $event)),
                      size: "mini",
                      filterable: "",
                      onChange: _ctx.deviceOutChange,
                      placeholder: "选择设备"
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_out_list, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item,
                            label: item.model,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "选择动作" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.action,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.action = $event)),
                      size: "mini",
                      filterable: "",
                      placeholder: "选择动作",
                      onChange: _ctx.actionChange
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.kingAction, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "选择指标" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.target_index_out,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.target_index_out = $event)),
                      size: "mini",
                      filterable: "",
                      placeholder: "选择指标",
                      onChange: _ctx.hokoutChange
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.target_types, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item,
                            label: item,
                            value: item
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_card, {
              class: "hok_card",
              style: {"background":"#393e44","border":"1px solid #fff"}
            }, {
              default: _withId(() => [
                _withDirectives(_createVNode("div", _hoisted_24, null, 512), [
                  [_directive_loading, _ctx.out_trend_loading]
                ])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
})